module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.hideDiv
    }
  }, [_c('div', [_c('topmenu')], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('leftmenu')], 1), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('router-view', {
    staticClass: "controlOverflow",
    staticStyle: {
      "position": "fixed",
      "top": "64px",
      "right": "0",
      "overflow": "auto"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-316d05e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/dashboard.vue
// module id = 974
// module chunks = 2